import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";

const SelectionByOwnSwapStep_11 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_10);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_12);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_11;
